import styled from "styled-components";

export const Container = styled.div`
  margin-top: 0.6rem;
  align-self: end;
  display: flex;
  width: 97%;
  height: 4rem;
  background-color: #fff;

  box-shadow: 0px 5.62941px 11.2588px rgba(88, 94, 102, 0.08);
  border-radius: 4.22206px;

  user-select: none;
  cursor: pointer;

  &:hover {
    background: #cff8e7;
  }

  transition: 0.15s ease-in-out background;
`;

export const Icon = styled.div`
  display: flex;

  width: 5%;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    width: 2.25rem;
    border-radius: 50%;
    border: 1px solid #40e5a0;
  }

  path {
    stroke: #a9aeb4;
  }
`;

export const TaskName = styled.span`
  width: 26%;
  align-items: center;
  display: flex;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  cursor: pointer;
`;

export const StatusSpace = styled.div`
  width: 25.8%;
  align-items: center;
  display: flex;
`;

export const TaskStatus = styled.span`
  padding: 0.2rem 0.7rem;
  border-radius: 0.2rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  background-color: ${({ status }) =>
    status === "doing"
      ? "#F8E47C"
      : status === "done"
        ? "#118052"
        : status === "doneLate"
          ? "#9F2D1D"
          : status === "pending"
            ? "#EFF1F5"
            : "#FFBAAB"};

  color: ${({ status }) =>
    status === "doing"
      ? "#786A23"
      : status === "done" || status === "doneLate"
        ? "#EFF1F5"
        : status === "pending"
          ? "#7E858F"
          : "#D93333"};
`;

export const DateSpace = styled.div`
  width: 30%;
  align-items: center;
  display: flex;
`;

export const TaskDate = styled.div`
  align-items: center;
  display: flex;

  padding: 0.2rem 0.7rem;
  border-radius: 0.2rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  background-color: ${({ status }) =>
    status === "doing"
      ? "#49B446"
      : status === "done"
        ? "#118052"
        : status === "doneLate"
          ? "#9F2D1D"
          : status === "pending"
            ? "#EFF1F5"
            : "#EB5757"};

  color: ${({ status }) => (status === "pending" ? "#7E858F" : "#FFFFFF")};

  path {
    stroke: ${({ status }) => (status === "pending" ? "#7E858F" : "#FFFFFF")};
  }
`;

export const TaskAtach = styled.div`
  width: 6%;
  align-items: center;
  display: flex;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  path {
    stroke: #7e858f;
  }
`;

export const TaskChat = styled.div`
  width: 6%;
  align-items: center;
  display: flex;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  path {
    stroke: #7e858f;
  }
`;
